module.exports = __webpack_public_path__ + "img/hc_pro_six_2.4dc47585.jpg";